import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import Form from "../../components/Form";
import PropTypes from "prop-types";
import { makeStyles } from "../../utils/styles";
import Button from "../../components/Button";
import useTheme from "../../hooks/useTheme";
import Box from "../../components/Box";
import FormLabel from "../../components/FormLabel";
import DatePicker from "../../components/DatePicker";
import IconWrap from "../../components/IconWrap";
import { addDays, differenceInDays, fromUnixTime, getUnixTime } from "date-fns";
import Icon from "../../components/Icon";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((css) => ({
    datePickers: css`
        display: flex;
        align-items: center;
    `,
    datePickersSeparator: css`
        margin: 0 12px 20px 12px;
    `,
    button: css`
        margin-left: 20px;
        margin-bottom: 20px;
    `
}));

const getPreloadedValues = (date) => ({
    time_start_from: getUnixTime(addDays(date, -7)),
    time_start_to: getUnixTime(date),
});

const FormDateFromTo = ({ loading, onSubmit }) => {
    const { t } = useTranslation()
    const styles = useStyles();
    const theme = useTheme();
    const { handleSubmit, watch, setValue, register } = useForm({
        defaultValues: {
            ...getPreloadedValues(new Date())
        }
    });

    const watchStartDate = fromUnixTime(watch('time_start_from'));
    const watchEndDate = fromUnixTime(watch('time_start_to'));

    useEffect(() => {
        register({ name: "time_start_from" });
        register({ name: "time_start_to" });
    }, [register]);

    useEffect(() => {
        if (differenceInDays(watchStartDate, watchEndDate) > 0) {
            setValue('time_start_to', getUnixTime(watchStartDate));
        }
    }, [watchStartDate, watchEndDate, setValue]);

    const handleChangeStartDate = date => setValue('time_start_from', getUnixTime(date));
    const handleChangeEndDate = date => setValue('time_start_to', getUnixTime(date));

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <FormLabel>{t("Data świadczenia pracy od - do")}</FormLabel>
            <Box customStyle={styles.datePickers}>
                <DatePicker
                    selected={watchStartDate}
                    onChange={handleChangeStartDate}
                    selectsStart
                    startDate={watchStartDate}
                    endDate={watchEndDate}
                />
                <IconWrap customStyle={styles.datePickersSeparator}>
                    <Icon name="minus" width={8} height={8} fill={theme.colors.darkGrey} />
                </IconWrap>
                <DatePicker
                    selected={watchEndDate}
                    onChange={handleChangeEndDate}
                    selectsEnd
                    startDate={watchStartDate}
                    endDate={watchEndDate}
                    minDate={watchStartDate}
                />
                <Button
                    type="submit"
                    customStyle={styles.button}
                    disabled={loading}
                >
                    {t("Filtruj")}
                </Button>
            </Box>
        </Form>
    );
};

FormDateFromTo.propTypes = {
    loading: PropTypes.bool,
    onSubmit: PropTypes.func
};

export default FormDateFromTo;
